import { GlobalStyles, Grid, Paper } from "@mui/material";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import React, { useContext, useEffect } from "react";
import { useHistory, useLocation } from "react-router-dom";
import { ArrowButon } from "../components/ArrowButton";
import { CardForm } from "../components/CardForm";
import NavigationMenu from "../components/NavigationMenu";
import { AppContext } from "../context";
import { useWindowDimensions } from "../hooks/useWindowDimensions";

function useQuery() {
  const { search } = useLocation();

  return React.useMemo(() => new URLSearchParams(search), [search]);
}

export function PaymentPage() {
  const {
    logo,
    lead,
    updateEvent,
    updateLead,
    getLeadByShortId,
    plan,
    getThemeAndPlans,
    theme,
    backgroundImage,
    acceptablePaymentMethods,
  } = useContext<any>(AppContext);
  const history = useHistory();
  let query = useQuery();
  const shortId = query.get("id");
  const productId = query.get("product");
  const { width } = useWindowDimensions();
  const background = theme ? theme.palette.background.default : "#fff";

  useEffect(() => {
    if (shortId && productId) {
      console.log(shortId, productId);
      setThemeAndLead();
    }
  }, [shortId, productId]);
  useEffect(() => {
    if (lead.leadId) {
      updateEvent({ type: "SQL", leadId: lead.leadId });
      updateLead({ sql: true });
    }
  }, [lead.leadId]);

  const setThemeAndLead = async () => {
    if (!lead.leadId) {
      console.log(shortId, productId);
      await getThemeAndPlans(productId);
      const res = await getLeadByShortId(shortId);
      console.log(res);
      updateEvent({ type: "SQL", leadId: res.leadId });
      updateLead({ sql: true });
    }
  };

  return (
    <>
      {plan && (
        <Box
          sx={{
            maxHeight: "100vh",
            width: "80vw",
            maxWidth: "1500px",
            margin: width > 375 ? "auto" : 1,
            paddingTop: "10px",
          }}
        >
          <GlobalStyles
            styles={{
              body: {
                backgroundColor: `${background}`,
                padding: "5px",
                height: "100vh",
              },
            }}
          />
          <Paper
            sx={{
              my: "auto",
              maxHeight: width > 400 ? 650 : "100vh",
              backgroundColor: "background.default",
              boxShadow: 0,
            }}
          >
            <Grid container>
              <Grid
                item
                xl={8}
                md={8}
                sm={12}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-evenly",
                  mb: width > 400 ? 0 : 2,
                  height: width > 400 ? 650 : "100vh",
                }}
              >
                <Box
                  sx={{
                    pl: width > 400 ? 8 : 3,
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-around",
                    mt: width > 400 ? 5 : 0,
                    mb: width > 400 ? 1 : 2,
                  }}
                >
                  <Box>
                    <img
                      src={logo}
                      alt=""
                      style={{ width: width > 400 ? theme.subAccountLogoWidth : '110px', marginBottom: '20px' }} 
                    />
                  </Box>
                  <Box
                    sx={{
                      position: "absolute",
                      top: 20,
                      left: 0,
                    }}
                  >
                    <ArrowButon path="/revisao" />
                  </Box>
                  <Box>
                    <Typography
                      sx={{
                        color: "primary.main",
                        fontSize: "1.8rem",
                        // fontWeight: 'bold',
                        fontFamily: 'Montserrat'
                      }}
                    >
                      Chegamos na reta final!
                    </Typography>
                  </Box>
                  <Box>
                    <Typography
                      sx={{ color: "primary.main", fontSize: "1.2rem", fontFamily: 'Montserrat' }}
                    >
                      Informe seus dados de pagamento!
                    </Typography>
                  </Box>
                  <Box sx={{ mt: 2, mb: 2 }}>
                    <Typography
                      sx={{ color: "secondary.main", fontSize: "1.8rem", fontFamily: 'Montserrat' }}
                    >
                      Plano Selecionado
                    </Typography>
                    <Typography
                      sx={{ color: "secondary.main", fontSize: "1.2rem", fontFamily: 'Montserrat' }}
                    >
                      <strong>{plan.plan_selected}:</strong> R$ {plan.price}
                    </Typography>
                    {plan.product_description && (
                      <Typography
                        sx={{ color: "secondary.main", fontSize: "1.2rem" }}
                      >
                        {plan.product_description}
                      </Typography>
                    )}
                  </Box>
                </Box>
                {!(
                  acceptablePaymentMethods.bankslip ||
                  acceptablePaymentMethods.pix
                ) ? (
                  <>
                    <Box
                      sx={{ mx: "auto", width: width > 375 ? "100%" : "350px" }}
                    >
                      <CardForm />
                    </Box>
                  </>
                ) : (
                  <>
                    <Box sx={{ width: "100%", m: "0 auto" }}>
                      <NavigationMenu />
                    </Box>
                  </>
                )}
              </Grid>
              {width > 1000 && (
                <Grid item xl={4} md={4} sm={0}>
                  <Box
                    sx={{
                      maxHeight: "100%",
                      width: "100%",
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <img src={backgroundImage} width="350px" alt="" />
                  </Box>
                </Grid>
              )}
            </Grid>
          </Paper>
        </Box>
      )}
    </>
  );
}
